import axios from 'axios';

export const historyService = {
  getHistoryService: (params) => axios.get('/history', { auth: true, params: { ...params } }),
};
